import 'moment/locale/zh-cn';
import React, { Suspense } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { isLogin, getSignToken, getPreviewAuth, getExamToken, getAdjustLeaveToken } from '@/core/authUtil';
import { getActCode, getExamCode } from '@/core/util';
import Loading from './Loading';
import routeConfig from './routeConfig';

const createRoutes = (routeConfigList = []) => {
  const routes = routeConfigList.map(({ needAuth = false, needSignAuth = false, needExamAuth = false, path, component: Component }) => {
    return (
      <Route
        exact
        key={path}
        path={path}
        render={(props) => {
          const { location } = props;
          if (needAuth && !isLogin()) {
            return <Redirect to={{ pathname: '/login', state: { from: location } }} />
          }
          if (needSignAuth && !getSignToken() && !getPreviewAuth() && (window.location.href?.indexOf('/signup') > -1 || window.location.href?.indexOf('/signUp') > -1)) {
            window.location.replace(`${window.origin}/signUp/login?actCode=${getActCode()}`)
            return
          }
          if (needExamAuth && !getExamToken() && !getPreviewAuth() && ((window.location.href?.indexOf('/exam') > -1))) {
            window.location.replace(`${window.origin}/exam/login?examCode=${getExamCode()}`)
            return
          }
          return <Component {...props} />
        }}
      />
    );
  });
  return routes;
}

export default function AppRouter() {
  const routeList = createRoutes(routeConfig);
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/">
          <Suspense fallback={<Loading />}>
            {routeList}
          </Suspense>
        </Route>
      </Switch>
    </BrowserRouter>
  );
}
